// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file annealing/delivery/v1/service.proto (package annealing.delivery.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_api_annotations } from "../../../google/api/annotations_pb";
import { file_google_api_field_behavior } from "../../../google/api/field_behavior_pb";
import { file_google_api_resource } from "../../../google/api/resource_pb";
import type { EmptySchema, FieldMask } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_field_mask } from "@bufbuild/protobuf/wkt";
import type { Application, ApplicationSchema, Asset, AssetSchema, Chart, ChartRepository, ChartRepositorySchema, Cluster, ClusterSchema, GitRepository, GitRepositorySchema, IgnoreDifference, IgnoreDifferenceSchema, Incarnation, IncarnationAsset, IncarnationAssetSchema, IncarnationFile, IncarnationFileSchema, IncarnationSchema, Rollout, RolloutAsset, RolloutAssetSchema, RolloutSchema, RolloutStep, RolloutStepSchema, SshKey, SshKeySchema, SshKnownHost, SshKnownHostSchema } from "./resources_pb";
import { file_annealing_delivery_v1_resources } from "./resources_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file annealing/delivery/v1/service.proto.
 */
export const file_annealing_delivery_v1_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_api_annotations, file_google_api_field_behavior, file_google_api_resource, file_google_protobuf_empty, file_google_protobuf_field_mask, file_annealing_delivery_v1_resources]);

/**
 * @generated from message annealing.delivery.v1.CreateSshKeyRequest
 */
export type CreateSshKeyRequest = Message<"annealing.delivery.v1.CreateSshKeyRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: annealing.delivery.v1.SshKey ssh_key = 2;
   */
  sshKey?: SshKey;

  /**
   * @generated from field: string ssh_key_id = 3;
   */
  sshKeyId: string;
};

/**
 * Describes the message annealing.delivery.v1.CreateSshKeyRequest.
 * Use `create(CreateSshKeyRequestSchema)` to create a new message.
 */
export const CreateSshKeyRequestSchema: GenMessage<CreateSshKeyRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 0);

/**
 * @generated from message annealing.delivery.v1.GetSshKeyRequest
 */
export type GetSshKeyRequest = Message<"annealing.delivery.v1.GetSshKeyRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.delivery.v1.GetSshKeyRequest.
 * Use `create(GetSshKeyRequestSchema)` to create a new message.
 */
export const GetSshKeyRequestSchema: GenMessage<GetSshKeyRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 1);

/**
 * @generated from message annealing.delivery.v1.ListSshKeysRequest
 */
export type ListSshKeysRequest = Message<"annealing.delivery.v1.ListSshKeysRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message annealing.delivery.v1.ListSshKeysRequest.
 * Use `create(ListSshKeysRequestSchema)` to create a new message.
 */
export const ListSshKeysRequestSchema: GenMessage<ListSshKeysRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 2);

/**
 * @generated from message annealing.delivery.v1.ListSshKeysResponse
 */
export type ListSshKeysResponse = Message<"annealing.delivery.v1.ListSshKeysResponse"> & {
  /**
   * @generated from field: repeated annealing.delivery.v1.SshKey ssh_keys = 1;
   */
  sshKeys: SshKey[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: string previous_page_token = 3;
   */
  previousPageToken: string;

  /**
   * @generated from field: int32 total_size = 4;
   */
  totalSize: number;

  /**
   * @generated from field: int32 start_index = 5;
   */
  startIndex: number;
};

/**
 * Describes the message annealing.delivery.v1.ListSshKeysResponse.
 * Use `create(ListSshKeysResponseSchema)` to create a new message.
 */
export const ListSshKeysResponseSchema: GenMessage<ListSshKeysResponse> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 3);

/**
 * @generated from message annealing.delivery.v1.DeleteSshKeyRequest
 */
export type DeleteSshKeyRequest = Message<"annealing.delivery.v1.DeleteSshKeyRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.delivery.v1.DeleteSshKeyRequest.
 * Use `create(DeleteSshKeyRequestSchema)` to create a new message.
 */
export const DeleteSshKeyRequestSchema: GenMessage<DeleteSshKeyRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 4);

/**
 * @generated from message annealing.delivery.v1.CreateSshKnownHostRequest
 */
export type CreateSshKnownHostRequest = Message<"annealing.delivery.v1.CreateSshKnownHostRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: annealing.delivery.v1.SshKnownHost ssh_known_host = 2;
   */
  sshKnownHost?: SshKnownHost;

  /**
   * @generated from field: string ssh_known_host_id = 3;
   */
  sshKnownHostId: string;
};

/**
 * Describes the message annealing.delivery.v1.CreateSshKnownHostRequest.
 * Use `create(CreateSshKnownHostRequestSchema)` to create a new message.
 */
export const CreateSshKnownHostRequestSchema: GenMessage<CreateSshKnownHostRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 5);

/**
 * @generated from message annealing.delivery.v1.GetSshKnownHostRequest
 */
export type GetSshKnownHostRequest = Message<"annealing.delivery.v1.GetSshKnownHostRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.delivery.v1.GetSshKnownHostRequest.
 * Use `create(GetSshKnownHostRequestSchema)` to create a new message.
 */
export const GetSshKnownHostRequestSchema: GenMessage<GetSshKnownHostRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 6);

/**
 * @generated from message annealing.delivery.v1.ListSshKnownHostsRequest
 */
export type ListSshKnownHostsRequest = Message<"annealing.delivery.v1.ListSshKnownHostsRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message annealing.delivery.v1.ListSshKnownHostsRequest.
 * Use `create(ListSshKnownHostsRequestSchema)` to create a new message.
 */
export const ListSshKnownHostsRequestSchema: GenMessage<ListSshKnownHostsRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 7);

/**
 * @generated from message annealing.delivery.v1.ListSshKnownHostsResponse
 */
export type ListSshKnownHostsResponse = Message<"annealing.delivery.v1.ListSshKnownHostsResponse"> & {
  /**
   * @generated from field: repeated annealing.delivery.v1.SshKnownHost ssh_known_hosts = 1;
   */
  sshKnownHosts: SshKnownHost[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: string previous_page_token = 3;
   */
  previousPageToken: string;

  /**
   * @generated from field: int32 total_size = 4;
   */
  totalSize: number;

  /**
   * @generated from field: int32 start_index = 5;
   */
  startIndex: number;
};

/**
 * Describes the message annealing.delivery.v1.ListSshKnownHostsResponse.
 * Use `create(ListSshKnownHostsResponseSchema)` to create a new message.
 */
export const ListSshKnownHostsResponseSchema: GenMessage<ListSshKnownHostsResponse> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 8);

/**
 * @generated from message annealing.delivery.v1.DeleteSshKnownHostRequest
 */
export type DeleteSshKnownHostRequest = Message<"annealing.delivery.v1.DeleteSshKnownHostRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.delivery.v1.DeleteSshKnownHostRequest.
 * Use `create(DeleteSshKnownHostRequestSchema)` to create a new message.
 */
export const DeleteSshKnownHostRequestSchema: GenMessage<DeleteSshKnownHostRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 9);

/**
 * @generated from message annealing.delivery.v1.CreateIgnoreDifferenceRequest
 */
export type CreateIgnoreDifferenceRequest = Message<"annealing.delivery.v1.CreateIgnoreDifferenceRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: annealing.delivery.v1.IgnoreDifference ignore_difference = 2;
   */
  ignoreDifference?: IgnoreDifference;

  /**
   * @generated from field: string ignore_difference_id = 3;
   */
  ignoreDifferenceId: string;
};

/**
 * Describes the message annealing.delivery.v1.CreateIgnoreDifferenceRequest.
 * Use `create(CreateIgnoreDifferenceRequestSchema)` to create a new message.
 */
export const CreateIgnoreDifferenceRequestSchema: GenMessage<CreateIgnoreDifferenceRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 10);

/**
 * @generated from message annealing.delivery.v1.GetIgnoreDifferenceRequest
 */
export type GetIgnoreDifferenceRequest = Message<"annealing.delivery.v1.GetIgnoreDifferenceRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.delivery.v1.GetIgnoreDifferenceRequest.
 * Use `create(GetIgnoreDifferenceRequestSchema)` to create a new message.
 */
export const GetIgnoreDifferenceRequestSchema: GenMessage<GetIgnoreDifferenceRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 11);

/**
 * @generated from message annealing.delivery.v1.ListIgnoreDifferencesRequest
 */
export type ListIgnoreDifferencesRequest = Message<"annealing.delivery.v1.ListIgnoreDifferencesRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message annealing.delivery.v1.ListIgnoreDifferencesRequest.
 * Use `create(ListIgnoreDifferencesRequestSchema)` to create a new message.
 */
export const ListIgnoreDifferencesRequestSchema: GenMessage<ListIgnoreDifferencesRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 12);

/**
 * @generated from message annealing.delivery.v1.ListIgnoreDifferencesResponse
 */
export type ListIgnoreDifferencesResponse = Message<"annealing.delivery.v1.ListIgnoreDifferencesResponse"> & {
  /**
   * @generated from field: repeated annealing.delivery.v1.IgnoreDifference ignore_differences = 1;
   */
  ignoreDifferences: IgnoreDifference[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: string previous_page_token = 3;
   */
  previousPageToken: string;

  /**
   * @generated from field: int32 total_size = 4;
   */
  totalSize: number;

  /**
   * @generated from field: int32 start_index = 5;
   */
  startIndex: number;
};

/**
 * Describes the message annealing.delivery.v1.ListIgnoreDifferencesResponse.
 * Use `create(ListIgnoreDifferencesResponseSchema)` to create a new message.
 */
export const ListIgnoreDifferencesResponseSchema: GenMessage<ListIgnoreDifferencesResponse> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 13);

/**
 * @generated from message annealing.delivery.v1.DeleteIgnoreDifferenceRequest
 */
export type DeleteIgnoreDifferenceRequest = Message<"annealing.delivery.v1.DeleteIgnoreDifferenceRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.delivery.v1.DeleteIgnoreDifferenceRequest.
 * Use `create(DeleteIgnoreDifferenceRequestSchema)` to create a new message.
 */
export const DeleteIgnoreDifferenceRequestSchema: GenMessage<DeleteIgnoreDifferenceRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 14);

/**
 * @generated from message annealing.delivery.v1.CreateClusterRequest
 */
export type CreateClusterRequest = Message<"annealing.delivery.v1.CreateClusterRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: annealing.delivery.v1.Cluster cluster = 2;
   */
  cluster?: Cluster;

  /**
   * @generated from field: string cluster_id = 3;
   */
  clusterId: string;
};

/**
 * Describes the message annealing.delivery.v1.CreateClusterRequest.
 * Use `create(CreateClusterRequestSchema)` to create a new message.
 */
export const CreateClusterRequestSchema: GenMessage<CreateClusterRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 15);

/**
 * @generated from message annealing.delivery.v1.GetClusterRequest
 */
export type GetClusterRequest = Message<"annealing.delivery.v1.GetClusterRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.delivery.v1.GetClusterRequest.
 * Use `create(GetClusterRequestSchema)` to create a new message.
 */
export const GetClusterRequestSchema: GenMessage<GetClusterRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 16);

/**
 * @generated from message annealing.delivery.v1.ListClustersRequest
 */
export type ListClustersRequest = Message<"annealing.delivery.v1.ListClustersRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message annealing.delivery.v1.ListClustersRequest.
 * Use `create(ListClustersRequestSchema)` to create a new message.
 */
export const ListClustersRequestSchema: GenMessage<ListClustersRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 17);

/**
 * @generated from message annealing.delivery.v1.ListClustersResponse
 */
export type ListClustersResponse = Message<"annealing.delivery.v1.ListClustersResponse"> & {
  /**
   * @generated from field: repeated annealing.delivery.v1.Cluster clusters = 1;
   */
  clusters: Cluster[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: string previous_page_token = 3;
   */
  previousPageToken: string;

  /**
   * @generated from field: int32 total_size = 4;
   */
  totalSize: number;

  /**
   * @generated from field: int32 start_index = 5;
   */
  startIndex: number;
};

/**
 * Describes the message annealing.delivery.v1.ListClustersResponse.
 * Use `create(ListClustersResponseSchema)` to create a new message.
 */
export const ListClustersResponseSchema: GenMessage<ListClustersResponse> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 18);

/**
 * @generated from message annealing.delivery.v1.DeleteClusterRequest
 */
export type DeleteClusterRequest = Message<"annealing.delivery.v1.DeleteClusterRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.delivery.v1.DeleteClusterRequest.
 * Use `create(DeleteClusterRequestSchema)` to create a new message.
 */
export const DeleteClusterRequestSchema: GenMessage<DeleteClusterRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 19);

/**
 * @generated from message annealing.delivery.v1.CreateApplicationRequest
 */
export type CreateApplicationRequest = Message<"annealing.delivery.v1.CreateApplicationRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: annealing.delivery.v1.Application application = 2;
   */
  application?: Application;

  /**
   * @generated from field: string application_id = 3;
   */
  applicationId: string;
};

/**
 * Describes the message annealing.delivery.v1.CreateApplicationRequest.
 * Use `create(CreateApplicationRequestSchema)` to create a new message.
 */
export const CreateApplicationRequestSchema: GenMessage<CreateApplicationRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 20);

/**
 * @generated from message annealing.delivery.v1.ListApplicationsRequest
 */
export type ListApplicationsRequest = Message<"annealing.delivery.v1.ListApplicationsRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message annealing.delivery.v1.ListApplicationsRequest.
 * Use `create(ListApplicationsRequestSchema)` to create a new message.
 */
export const ListApplicationsRequestSchema: GenMessage<ListApplicationsRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 21);

/**
 * @generated from message annealing.delivery.v1.ListApplicationsResponse
 */
export type ListApplicationsResponse = Message<"annealing.delivery.v1.ListApplicationsResponse"> & {
  /**
   * @generated from field: repeated annealing.delivery.v1.Application applications = 1;
   */
  applications: Application[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: string previous_page_token = 3;
   */
  previousPageToken: string;

  /**
   * @generated from field: int32 total_size = 4;
   */
  totalSize: number;

  /**
   * @generated from field: int32 start_index = 5;
   */
  startIndex: number;
};

/**
 * Describes the message annealing.delivery.v1.ListApplicationsResponse.
 * Use `create(ListApplicationsResponseSchema)` to create a new message.
 */
export const ListApplicationsResponseSchema: GenMessage<ListApplicationsResponse> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 22);

/**
 * @generated from message annealing.delivery.v1.GetApplicationRequest
 */
export type GetApplicationRequest = Message<"annealing.delivery.v1.GetApplicationRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.delivery.v1.GetApplicationRequest.
 * Use `create(GetApplicationRequestSchema)` to create a new message.
 */
export const GetApplicationRequestSchema: GenMessage<GetApplicationRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 23);

/**
 * @generated from message annealing.delivery.v1.UpdateApplicationRequest
 */
export type UpdateApplicationRequest = Message<"annealing.delivery.v1.UpdateApplicationRequest"> & {
  /**
   * @generated from field: annealing.delivery.v1.Application application = 1;
   */
  application?: Application;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message annealing.delivery.v1.UpdateApplicationRequest.
 * Use `create(UpdateApplicationRequestSchema)` to create a new message.
 */
export const UpdateApplicationRequestSchema: GenMessage<UpdateApplicationRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 24);

/**
 * @generated from message annealing.delivery.v1.DeleteApplicationRequest
 */
export type DeleteApplicationRequest = Message<"annealing.delivery.v1.DeleteApplicationRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.delivery.v1.DeleteApplicationRequest.
 * Use `create(DeleteApplicationRequestSchema)` to create a new message.
 */
export const DeleteApplicationRequestSchema: GenMessage<DeleteApplicationRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 25);

/**
 * @generated from message annealing.delivery.v1.GetIncarnationRequest
 */
export type GetIncarnationRequest = Message<"annealing.delivery.v1.GetIncarnationRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.delivery.v1.GetIncarnationRequest.
 * Use `create(GetIncarnationRequestSchema)` to create a new message.
 */
export const GetIncarnationRequestSchema: GenMessage<GetIncarnationRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 26);

/**
 * @generated from message annealing.delivery.v1.ListIncarnationsRequest
 */
export type ListIncarnationsRequest = Message<"annealing.delivery.v1.ListIncarnationsRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message annealing.delivery.v1.ListIncarnationsRequest.
 * Use `create(ListIncarnationsRequestSchema)` to create a new message.
 */
export const ListIncarnationsRequestSchema: GenMessage<ListIncarnationsRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 27);

/**
 * @generated from message annealing.delivery.v1.ListIncarnationsResponse
 */
export type ListIncarnationsResponse = Message<"annealing.delivery.v1.ListIncarnationsResponse"> & {
  /**
   * @generated from field: repeated annealing.delivery.v1.Incarnation incarnations = 1;
   */
  incarnations: Incarnation[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: string previous_page_token = 3;
   */
  previousPageToken: string;

  /**
   * @generated from field: int32 total_size = 4;
   */
  totalSize: number;

  /**
   * @generated from field: int32 start_index = 5;
   */
  startIndex: number;
};

/**
 * Describes the message annealing.delivery.v1.ListIncarnationsResponse.
 * Use `create(ListIncarnationsResponseSchema)` to create a new message.
 */
export const ListIncarnationsResponseSchema: GenMessage<ListIncarnationsResponse> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 28);

/**
 * @generated from message annealing.delivery.v1.GetIncarnationFileRequest
 */
export type GetIncarnationFileRequest = Message<"annealing.delivery.v1.GetIncarnationFileRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.delivery.v1.GetIncarnationFileRequest.
 * Use `create(GetIncarnationFileRequestSchema)` to create a new message.
 */
export const GetIncarnationFileRequestSchema: GenMessage<GetIncarnationFileRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 29);

/**
 * @generated from message annealing.delivery.v1.ListIncarnationFilesRequest
 */
export type ListIncarnationFilesRequest = Message<"annealing.delivery.v1.ListIncarnationFilesRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;
};

/**
 * Describes the message annealing.delivery.v1.ListIncarnationFilesRequest.
 * Use `create(ListIncarnationFilesRequestSchema)` to create a new message.
 */
export const ListIncarnationFilesRequestSchema: GenMessage<ListIncarnationFilesRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 30);

/**
 * @generated from message annealing.delivery.v1.ListIncarnationFilesResponse
 */
export type ListIncarnationFilesResponse = Message<"annealing.delivery.v1.ListIncarnationFilesResponse"> & {
  /**
   * @generated from field: repeated annealing.delivery.v1.IncarnationFile incarnation_files = 1;
   */
  incarnationFiles: IncarnationFile[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: string previous_page_token = 3;
   */
  previousPageToken: string;

  /**
   * @generated from field: int32 total_size = 4;
   */
  totalSize: number;

  /**
   * @generated from field: int32 start_index = 5;
   */
  startIndex: number;
};

/**
 * Describes the message annealing.delivery.v1.ListIncarnationFilesResponse.
 * Use `create(ListIncarnationFilesResponseSchema)` to create a new message.
 */
export const ListIncarnationFilesResponseSchema: GenMessage<ListIncarnationFilesResponse> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 31);

/**
 * @generated from message annealing.delivery.v1.GetIncarnationAssetRequest
 */
export type GetIncarnationAssetRequest = Message<"annealing.delivery.v1.GetIncarnationAssetRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.delivery.v1.GetIncarnationAssetRequest.
 * Use `create(GetIncarnationAssetRequestSchema)` to create a new message.
 */
export const GetIncarnationAssetRequestSchema: GenMessage<GetIncarnationAssetRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 32);

/**
 * @generated from message annealing.delivery.v1.ListIncarnationAssetsRequest
 */
export type ListIncarnationAssetsRequest = Message<"annealing.delivery.v1.ListIncarnationAssetsRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;
};

/**
 * Describes the message annealing.delivery.v1.ListIncarnationAssetsRequest.
 * Use `create(ListIncarnationAssetsRequestSchema)` to create a new message.
 */
export const ListIncarnationAssetsRequestSchema: GenMessage<ListIncarnationAssetsRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 33);

/**
 * @generated from message annealing.delivery.v1.ListIncarnationAssetsResponse
 */
export type ListIncarnationAssetsResponse = Message<"annealing.delivery.v1.ListIncarnationAssetsResponse"> & {
  /**
   * @generated from field: repeated annealing.delivery.v1.IncarnationAsset incarnation_assets = 1;
   */
  incarnationAssets: IncarnationAsset[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: string previous_page_token = 3;
   */
  previousPageToken: string;

  /**
   * @generated from field: int32 total_size = 4;
   */
  totalSize: number;

  /**
   * @generated from field: int32 start_index = 5;
   */
  startIndex: number;
};

/**
 * Describes the message annealing.delivery.v1.ListIncarnationAssetsResponse.
 * Use `create(ListIncarnationAssetsResponseSchema)` to create a new message.
 */
export const ListIncarnationAssetsResponseSchema: GenMessage<ListIncarnationAssetsResponse> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 34);

/**
 * @generated from message annealing.delivery.v1.ListAssetsRequest
 */
export type ListAssetsRequest = Message<"annealing.delivery.v1.ListAssetsRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message annealing.delivery.v1.ListAssetsRequest.
 * Use `create(ListAssetsRequestSchema)` to create a new message.
 */
export const ListAssetsRequestSchema: GenMessage<ListAssetsRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 35);

/**
 * @generated from message annealing.delivery.v1.ListAssetsResponse
 */
export type ListAssetsResponse = Message<"annealing.delivery.v1.ListAssetsResponse"> & {
  /**
   * @generated from field: repeated annealing.delivery.v1.Asset assets = 1;
   */
  assets: Asset[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: string previous_page_token = 3;
   */
  previousPageToken: string;

  /**
   * @generated from field: int32 total_size = 4;
   */
  totalSize: number;

  /**
   * @generated from field: int32 start_index = 5;
   */
  startIndex: number;
};

/**
 * Describes the message annealing.delivery.v1.ListAssetsResponse.
 * Use `create(ListAssetsResponseSchema)` to create a new message.
 */
export const ListAssetsResponseSchema: GenMessage<ListAssetsResponse> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 36);

/**
 * @generated from message annealing.delivery.v1.GetAssetRequest
 */
export type GetAssetRequest = Message<"annealing.delivery.v1.GetAssetRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.delivery.v1.GetAssetRequest.
 * Use `create(GetAssetRequestSchema)` to create a new message.
 */
export const GetAssetRequestSchema: GenMessage<GetAssetRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 37);

/**
 * @generated from message annealing.delivery.v1.GetRolloutRequest
 */
export type GetRolloutRequest = Message<"annealing.delivery.v1.GetRolloutRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.delivery.v1.GetRolloutRequest.
 * Use `create(GetRolloutRequestSchema)` to create a new message.
 */
export const GetRolloutRequestSchema: GenMessage<GetRolloutRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 38);

/**
 * @generated from message annealing.delivery.v1.ListRolloutsRequest
 */
export type ListRolloutsRequest = Message<"annealing.delivery.v1.ListRolloutsRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message annealing.delivery.v1.ListRolloutsRequest.
 * Use `create(ListRolloutsRequestSchema)` to create a new message.
 */
export const ListRolloutsRequestSchema: GenMessage<ListRolloutsRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 39);

/**
 * @generated from message annealing.delivery.v1.ListRolloutsResponse
 */
export type ListRolloutsResponse = Message<"annealing.delivery.v1.ListRolloutsResponse"> & {
  /**
   * @generated from field: repeated annealing.delivery.v1.Rollout rollouts = 1;
   */
  rollouts: Rollout[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: string previous_page_token = 3;
   */
  previousPageToken: string;

  /**
   * @generated from field: int32 total_size = 4;
   */
  totalSize: number;

  /**
   * @generated from field: int32 start_index = 5;
   */
  startIndex: number;
};

/**
 * Describes the message annealing.delivery.v1.ListRolloutsResponse.
 * Use `create(ListRolloutsResponseSchema)` to create a new message.
 */
export const ListRolloutsResponseSchema: GenMessage<ListRolloutsResponse> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 40);

/**
 * @generated from message annealing.delivery.v1.SearchRolloutsRequest
 */
export type SearchRolloutsRequest = Message<"annealing.delivery.v1.SearchRolloutsRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message annealing.delivery.v1.SearchRolloutsRequest.
 * Use `create(SearchRolloutsRequestSchema)` to create a new message.
 */
export const SearchRolloutsRequestSchema: GenMessage<SearchRolloutsRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 41);

/**
 * @generated from message annealing.delivery.v1.SearchRolloutsResponse
 */
export type SearchRolloutsResponse = Message<"annealing.delivery.v1.SearchRolloutsResponse"> & {
  /**
   * @generated from field: repeated annealing.delivery.v1.Rollout rollouts = 1;
   */
  rollouts: Rollout[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: string previous_page_token = 3;
   */
  previousPageToken: string;

  /**
   * @generated from field: int32 total_size = 4;
   */
  totalSize: number;

  /**
   * @generated from field: int32 start_index = 5;
   */
  startIndex: number;
};

/**
 * Describes the message annealing.delivery.v1.SearchRolloutsResponse.
 * Use `create(SearchRolloutsResponseSchema)` to create a new message.
 */
export const SearchRolloutsResponseSchema: GenMessage<SearchRolloutsResponse> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 42);

/**
 * @generated from message annealing.delivery.v1.PauseRolloutRequest
 */
export type PauseRolloutRequest = Message<"annealing.delivery.v1.PauseRolloutRequest"> & {
};

/**
 * Describes the message annealing.delivery.v1.PauseRolloutRequest.
 * Use `create(PauseRolloutRequestSchema)` to create a new message.
 */
export const PauseRolloutRequestSchema: GenMessage<PauseRolloutRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 43);

/**
 * @generated from message annealing.delivery.v1.PauseRolloutResponse
 */
export type PauseRolloutResponse = Message<"annealing.delivery.v1.PauseRolloutResponse"> & {
};

/**
 * Describes the message annealing.delivery.v1.PauseRolloutResponse.
 * Use `create(PauseRolloutResponseSchema)` to create a new message.
 */
export const PauseRolloutResponseSchema: GenMessage<PauseRolloutResponse> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 44);

/**
 * @generated from message annealing.delivery.v1.ResumeRolloutRequest
 */
export type ResumeRolloutRequest = Message<"annealing.delivery.v1.ResumeRolloutRequest"> & {
};

/**
 * Describes the message annealing.delivery.v1.ResumeRolloutRequest.
 * Use `create(ResumeRolloutRequestSchema)` to create a new message.
 */
export const ResumeRolloutRequestSchema: GenMessage<ResumeRolloutRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 45);

/**
 * @generated from message annealing.delivery.v1.ResumeRolloutResponse
 */
export type ResumeRolloutResponse = Message<"annealing.delivery.v1.ResumeRolloutResponse"> & {
};

/**
 * Describes the message annealing.delivery.v1.ResumeRolloutResponse.
 * Use `create(ResumeRolloutResponseSchema)` to create a new message.
 */
export const ResumeRolloutResponseSchema: GenMessage<ResumeRolloutResponse> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 46);

/**
 * @generated from message annealing.delivery.v1.CancelRolloutRequest
 */
export type CancelRolloutRequest = Message<"annealing.delivery.v1.CancelRolloutRequest"> & {
};

/**
 * Describes the message annealing.delivery.v1.CancelRolloutRequest.
 * Use `create(CancelRolloutRequestSchema)` to create a new message.
 */
export const CancelRolloutRequestSchema: GenMessage<CancelRolloutRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 47);

/**
 * @generated from message annealing.delivery.v1.CancelRolloutResponse
 */
export type CancelRolloutResponse = Message<"annealing.delivery.v1.CancelRolloutResponse"> & {
};

/**
 * Describes the message annealing.delivery.v1.CancelRolloutResponse.
 * Use `create(CancelRolloutResponseSchema)` to create a new message.
 */
export const CancelRolloutResponseSchema: GenMessage<CancelRolloutResponse> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 48);

/**
 * @generated from message annealing.delivery.v1.GetRolloutStepRequest
 */
export type GetRolloutStepRequest = Message<"annealing.delivery.v1.GetRolloutStepRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.delivery.v1.GetRolloutStepRequest.
 * Use `create(GetRolloutStepRequestSchema)` to create a new message.
 */
export const GetRolloutStepRequestSchema: GenMessage<GetRolloutStepRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 49);

/**
 * @generated from message annealing.delivery.v1.ListRolloutStepsRequest
 */
export type ListRolloutStepsRequest = Message<"annealing.delivery.v1.ListRolloutStepsRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message annealing.delivery.v1.ListRolloutStepsRequest.
 * Use `create(ListRolloutStepsRequestSchema)` to create a new message.
 */
export const ListRolloutStepsRequestSchema: GenMessage<ListRolloutStepsRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 50);

/**
 * @generated from message annealing.delivery.v1.ListRolloutStepsResponse
 */
export type ListRolloutStepsResponse = Message<"annealing.delivery.v1.ListRolloutStepsResponse"> & {
  /**
   * @generated from field: repeated annealing.delivery.v1.RolloutStep rollout_steps = 1;
   */
  rolloutSteps: RolloutStep[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: string previous_page_token = 3;
   */
  previousPageToken: string;

  /**
   * @generated from field: int32 total_size = 4;
   */
  totalSize: number;

  /**
   * @generated from field: int32 start_index = 5;
   */
  startIndex: number;
};

/**
 * Describes the message annealing.delivery.v1.ListRolloutStepsResponse.
 * Use `create(ListRolloutStepsResponseSchema)` to create a new message.
 */
export const ListRolloutStepsResponseSchema: GenMessage<ListRolloutStepsResponse> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 51);

/**
 * @generated from message annealing.delivery.v1.GetRolloutAssetRequest
 */
export type GetRolloutAssetRequest = Message<"annealing.delivery.v1.GetRolloutAssetRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.delivery.v1.GetRolloutAssetRequest.
 * Use `create(GetRolloutAssetRequestSchema)` to create a new message.
 */
export const GetRolloutAssetRequestSchema: GenMessage<GetRolloutAssetRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 52);

/**
 * @generated from message annealing.delivery.v1.ListRolloutAssetsRequest
 */
export type ListRolloutAssetsRequest = Message<"annealing.delivery.v1.ListRolloutAssetsRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message annealing.delivery.v1.ListRolloutAssetsRequest.
 * Use `create(ListRolloutAssetsRequestSchema)` to create a new message.
 */
export const ListRolloutAssetsRequestSchema: GenMessage<ListRolloutAssetsRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 53);

/**
 * @generated from message annealing.delivery.v1.ListRolloutAssetsResponse
 */
export type ListRolloutAssetsResponse = Message<"annealing.delivery.v1.ListRolloutAssetsResponse"> & {
  /**
   * @generated from field: repeated annealing.delivery.v1.RolloutAsset rollout_assets = 1;
   */
  rolloutAssets: RolloutAsset[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: string previous_page_token = 3;
   */
  previousPageToken: string;

  /**
   * @generated from field: int32 total_size = 4;
   */
  totalSize: number;

  /**
   * @generated from field: int32 start_index = 5;
   */
  startIndex: number;
};

/**
 * Describes the message annealing.delivery.v1.ListRolloutAssetsResponse.
 * Use `create(ListRolloutAssetsResponseSchema)` to create a new message.
 */
export const ListRolloutAssetsResponseSchema: GenMessage<ListRolloutAssetsResponse> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 54);

/**
 * @generated from message annealing.delivery.v1.ListChartRepositoriesRequest
 */
export type ListChartRepositoriesRequest = Message<"annealing.delivery.v1.ListChartRepositoriesRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message annealing.delivery.v1.ListChartRepositoriesRequest.
 * Use `create(ListChartRepositoriesRequestSchema)` to create a new message.
 */
export const ListChartRepositoriesRequestSchema: GenMessage<ListChartRepositoriesRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 55);

/**
 * @generated from message annealing.delivery.v1.ListChartRepositoriesResponse
 */
export type ListChartRepositoriesResponse = Message<"annealing.delivery.v1.ListChartRepositoriesResponse"> & {
  /**
   * @generated from field: repeated annealing.delivery.v1.ChartRepository chart_repositories = 1;
   */
  chartRepositories: ChartRepository[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: string previous_page_token = 3;
   */
  previousPageToken: string;

  /**
   * @generated from field: int32 total_size = 4;
   */
  totalSize: number;

  /**
   * @generated from field: int32 start_index = 5;
   */
  startIndex: number;
};

/**
 * Describes the message annealing.delivery.v1.ListChartRepositoriesResponse.
 * Use `create(ListChartRepositoriesResponseSchema)` to create a new message.
 */
export const ListChartRepositoriesResponseSchema: GenMessage<ListChartRepositoriesResponse> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 56);

/**
 * @generated from message annealing.delivery.v1.GetChartRepositoryRequest
 */
export type GetChartRepositoryRequest = Message<"annealing.delivery.v1.GetChartRepositoryRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.delivery.v1.GetChartRepositoryRequest.
 * Use `create(GetChartRepositoryRequestSchema)` to create a new message.
 */
export const GetChartRepositoryRequestSchema: GenMessage<GetChartRepositoryRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 57);

/**
 * @generated from message annealing.delivery.v1.CreateChartRepositoryRequest
 */
export type CreateChartRepositoryRequest = Message<"annealing.delivery.v1.CreateChartRepositoryRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: annealing.delivery.v1.ChartRepository chart_repository = 2;
   */
  chartRepository?: ChartRepository;

  /**
   * @generated from field: string chart_repository_id = 3;
   */
  chartRepositoryId: string;
};

/**
 * Describes the message annealing.delivery.v1.CreateChartRepositoryRequest.
 * Use `create(CreateChartRepositoryRequestSchema)` to create a new message.
 */
export const CreateChartRepositoryRequestSchema: GenMessage<CreateChartRepositoryRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 58);

/**
 * @generated from message annealing.delivery.v1.DeleteChartRepositoryRequest
 */
export type DeleteChartRepositoryRequest = Message<"annealing.delivery.v1.DeleteChartRepositoryRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.delivery.v1.DeleteChartRepositoryRequest.
 * Use `create(DeleteChartRepositoryRequestSchema)` to create a new message.
 */
export const DeleteChartRepositoryRequestSchema: GenMessage<DeleteChartRepositoryRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 59);

/**
 * @generated from message annealing.delivery.v1.ListGitRepositoriesRequest
 */
export type ListGitRepositoriesRequest = Message<"annealing.delivery.v1.ListGitRepositoriesRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message annealing.delivery.v1.ListGitRepositoriesRequest.
 * Use `create(ListGitRepositoriesRequestSchema)` to create a new message.
 */
export const ListGitRepositoriesRequestSchema: GenMessage<ListGitRepositoriesRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 60);

/**
 * @generated from message annealing.delivery.v1.ListGitRepositoriesResponse
 */
export type ListGitRepositoriesResponse = Message<"annealing.delivery.v1.ListGitRepositoriesResponse"> & {
  /**
   * @generated from field: repeated annealing.delivery.v1.GitRepository git_repositories = 1;
   */
  gitRepositories: GitRepository[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: string previous_page_token = 3;
   */
  previousPageToken: string;

  /**
   * @generated from field: int32 total_size = 4;
   */
  totalSize: number;

  /**
   * @generated from field: int32 start_index = 5;
   */
  startIndex: number;
};

/**
 * Describes the message annealing.delivery.v1.ListGitRepositoriesResponse.
 * Use `create(ListGitRepositoriesResponseSchema)` to create a new message.
 */
export const ListGitRepositoriesResponseSchema: GenMessage<ListGitRepositoriesResponse> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 61);

/**
 * @generated from message annealing.delivery.v1.GetGitRepositoryRequest
 */
export type GetGitRepositoryRequest = Message<"annealing.delivery.v1.GetGitRepositoryRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.delivery.v1.GetGitRepositoryRequest.
 * Use `create(GetGitRepositoryRequestSchema)` to create a new message.
 */
export const GetGitRepositoryRequestSchema: GenMessage<GetGitRepositoryRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 62);

/**
 * @generated from message annealing.delivery.v1.CreateGitRepositoryRequest
 */
export type CreateGitRepositoryRequest = Message<"annealing.delivery.v1.CreateGitRepositoryRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: annealing.delivery.v1.GitRepository git_repository = 2;
   */
  gitRepository?: GitRepository;

  /**
   * @generated from field: string git_repository_id = 3;
   */
  gitRepositoryId: string;
};

/**
 * Describes the message annealing.delivery.v1.CreateGitRepositoryRequest.
 * Use `create(CreateGitRepositoryRequestSchema)` to create a new message.
 */
export const CreateGitRepositoryRequestSchema: GenMessage<CreateGitRepositoryRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 63);

/**
 * @generated from message annealing.delivery.v1.DeleteGitRepositoryRequest
 */
export type DeleteGitRepositoryRequest = Message<"annealing.delivery.v1.DeleteGitRepositoryRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message annealing.delivery.v1.DeleteGitRepositoryRequest.
 * Use `create(DeleteGitRepositoryRequestSchema)` to create a new message.
 */
export const DeleteGitRepositoryRequestSchema: GenMessage<DeleteGitRepositoryRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 64);

/**
 * @generated from message annealing.delivery.v1.ListChartsRequest
 */
export type ListChartsRequest = Message<"annealing.delivery.v1.ListChartsRequest"> & {
  /**
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message annealing.delivery.v1.ListChartsRequest.
 * Use `create(ListChartsRequestSchema)` to create a new message.
 */
export const ListChartsRequestSchema: GenMessage<ListChartsRequest> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 65);

/**
 * @generated from message annealing.delivery.v1.ListChartsResponse
 */
export type ListChartsResponse = Message<"annealing.delivery.v1.ListChartsResponse"> & {
  /**
   * @generated from field: repeated annealing.delivery.v1.Chart charts = 1;
   */
  charts: Chart[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: string previous_page_token = 3;
   */
  previousPageToken: string;

  /**
   * @generated from field: int32 total_size = 4;
   */
  totalSize: number;

  /**
   * @generated from field: int32 start_index = 5;
   */
  startIndex: number;
};

/**
 * Describes the message annealing.delivery.v1.ListChartsResponse.
 * Use `create(ListChartsResponseSchema)` to create a new message.
 */
export const ListChartsResponseSchema: GenMessage<ListChartsResponse> = /*@__PURE__*/
  messageDesc(file_annealing_delivery_v1_service, 66);

/**
 * @generated from service annealing.delivery.v1.DeliveryService
 */
export const DeliveryService: GenService<{
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.GetSshKey
   */
  getSshKey: {
    methodKind: "unary";
    input: typeof GetSshKeyRequestSchema;
    output: typeof SshKeySchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.ListSshKeys
   */
  listSshKeys: {
    methodKind: "unary";
    input: typeof ListSshKeysRequestSchema;
    output: typeof ListSshKeysResponseSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.CreateSshKey
   */
  createSshKey: {
    methodKind: "unary";
    input: typeof CreateSshKeyRequestSchema;
    output: typeof SshKeySchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.DeleteSshKey
   */
  deleteSshKey: {
    methodKind: "unary";
    input: typeof DeleteSshKeyRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.GetSshKnownHost
   */
  getSshKnownHost: {
    methodKind: "unary";
    input: typeof GetSshKnownHostRequestSchema;
    output: typeof SshKnownHostSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.ListSshKnownHosts
   */
  listSshKnownHosts: {
    methodKind: "unary";
    input: typeof ListSshKnownHostsRequestSchema;
    output: typeof ListSshKnownHostsResponseSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.CreateSshKnownHost
   */
  createSshKnownHost: {
    methodKind: "unary";
    input: typeof CreateSshKnownHostRequestSchema;
    output: typeof SshKnownHostSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.DeleteSshKnownHost
   */
  deleteSshKnownHost: {
    methodKind: "unary";
    input: typeof DeleteSshKnownHostRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.GetIgnoreDifference
   */
  getIgnoreDifference: {
    methodKind: "unary";
    input: typeof GetIgnoreDifferenceRequestSchema;
    output: typeof IgnoreDifferenceSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.ListIgnoreDifferences
   */
  listIgnoreDifferences: {
    methodKind: "unary";
    input: typeof ListIgnoreDifferencesRequestSchema;
    output: typeof ListIgnoreDifferencesResponseSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.CreateIgnoreDifference
   */
  createIgnoreDifference: {
    methodKind: "unary";
    input: typeof CreateIgnoreDifferenceRequestSchema;
    output: typeof IgnoreDifferenceSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.DeleteIgnoreDifference
   */
  deleteIgnoreDifference: {
    methodKind: "unary";
    input: typeof DeleteIgnoreDifferenceRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.GetCluster
   */
  getCluster: {
    methodKind: "unary";
    input: typeof GetClusterRequestSchema;
    output: typeof ClusterSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.ListClusters
   */
  listClusters: {
    methodKind: "unary";
    input: typeof ListClustersRequestSchema;
    output: typeof ListClustersResponseSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.CreateCluster
   */
  createCluster: {
    methodKind: "unary";
    input: typeof CreateClusterRequestSchema;
    output: typeof ClusterSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.DeleteCluster
   */
  deleteCluster: {
    methodKind: "unary";
    input: typeof DeleteClusterRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.GetApplication
   */
  getApplication: {
    methodKind: "unary";
    input: typeof GetApplicationRequestSchema;
    output: typeof ApplicationSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.ListApplications
   */
  listApplications: {
    methodKind: "unary";
    input: typeof ListApplicationsRequestSchema;
    output: typeof ListApplicationsResponseSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.CreateApplication
   */
  createApplication: {
    methodKind: "unary";
    input: typeof CreateApplicationRequestSchema;
    output: typeof ApplicationSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.UpdateApplication
   */
  updateApplication: {
    methodKind: "unary";
    input: typeof UpdateApplicationRequestSchema;
    output: typeof ApplicationSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.DeleteApplication
   */
  deleteApplication: {
    methodKind: "unary";
    input: typeof DeleteApplicationRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.GetIncarnation
   */
  getIncarnation: {
    methodKind: "unary";
    input: typeof GetIncarnationRequestSchema;
    output: typeof IncarnationSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.ListIncarnations
   */
  listIncarnations: {
    methodKind: "unary";
    input: typeof ListIncarnationsRequestSchema;
    output: typeof ListIncarnationsResponseSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.GetIncarnationFile
   */
  getIncarnationFile: {
    methodKind: "unary";
    input: typeof GetIncarnationFileRequestSchema;
    output: typeof IncarnationFileSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.ListIncarnationFiles
   */
  listIncarnationFiles: {
    methodKind: "unary";
    input: typeof ListIncarnationFilesRequestSchema;
    output: typeof ListIncarnationFilesResponseSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.GetIncarnationAsset
   */
  getIncarnationAsset: {
    methodKind: "unary";
    input: typeof GetIncarnationAssetRequestSchema;
    output: typeof IncarnationAssetSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.ListIncarnationAssets
   */
  listIncarnationAssets: {
    methodKind: "unary";
    input: typeof ListIncarnationAssetsRequestSchema;
    output: typeof ListIncarnationAssetsResponseSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.GetAsset
   */
  getAsset: {
    methodKind: "unary";
    input: typeof GetAssetRequestSchema;
    output: typeof AssetSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.ListAssets
   */
  listAssets: {
    methodKind: "unary";
    input: typeof ListAssetsRequestSchema;
    output: typeof ListAssetsResponseSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.GetRollout
   */
  getRollout: {
    methodKind: "unary";
    input: typeof GetRolloutRequestSchema;
    output: typeof RolloutSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.ListRollouts
   */
  listRollouts: {
    methodKind: "unary";
    input: typeof ListRolloutsRequestSchema;
    output: typeof ListRolloutsResponseSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.SearchRollouts
   */
  searchRollouts: {
    methodKind: "unary";
    input: typeof SearchRolloutsRequestSchema;
    output: typeof SearchRolloutsResponseSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.PauseRollout
   */
  pauseRollout: {
    methodKind: "unary";
    input: typeof PauseRolloutRequestSchema;
    output: typeof PauseRolloutResponseSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.ResumeRollout
   */
  resumeRollout: {
    methodKind: "unary";
    input: typeof ResumeRolloutRequestSchema;
    output: typeof ResumeRolloutResponseSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.CancelRollout
   */
  cancelRollout: {
    methodKind: "unary";
    input: typeof CancelRolloutRequestSchema;
    output: typeof CancelRolloutResponseSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.GetRolloutStep
   */
  getRolloutStep: {
    methodKind: "unary";
    input: typeof GetRolloutStepRequestSchema;
    output: typeof RolloutStepSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.ListRolloutSteps
   */
  listRolloutSteps: {
    methodKind: "unary";
    input: typeof ListRolloutStepsRequestSchema;
    output: typeof ListRolloutStepsResponseSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.GetRolloutAsset
   */
  getRolloutAsset: {
    methodKind: "unary";
    input: typeof GetRolloutAssetRequestSchema;
    output: typeof RolloutAssetSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.ListRolloutAssets
   */
  listRolloutAssets: {
    methodKind: "unary";
    input: typeof ListRolloutAssetsRequestSchema;
    output: typeof ListRolloutAssetsResponseSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.GetGitRepository
   */
  getGitRepository: {
    methodKind: "unary";
    input: typeof GetGitRepositoryRequestSchema;
    output: typeof GitRepositorySchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.ListGitRepositories
   */
  listGitRepositories: {
    methodKind: "unary";
    input: typeof ListGitRepositoriesRequestSchema;
    output: typeof ListGitRepositoriesResponseSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.CreateGitRepository
   */
  createGitRepository: {
    methodKind: "unary";
    input: typeof CreateGitRepositoryRequestSchema;
    output: typeof GitRepositorySchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.DeleteGitRepository
   */
  deleteGitRepository: {
    methodKind: "unary";
    input: typeof DeleteGitRepositoryRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.GetChartRepository
   */
  getChartRepository: {
    methodKind: "unary";
    input: typeof GetChartRepositoryRequestSchema;
    output: typeof ChartRepositorySchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.ListChartRepositories
   */
  listChartRepositories: {
    methodKind: "unary";
    input: typeof ListChartRepositoriesRequestSchema;
    output: typeof ListChartRepositoriesResponseSchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.CreateChartRepository
   */
  createChartRepository: {
    methodKind: "unary";
    input: typeof CreateChartRepositoryRequestSchema;
    output: typeof ChartRepositorySchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.DeleteChartRepository
   */
  deleteChartRepository: {
    methodKind: "unary";
    input: typeof DeleteChartRepositoryRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc annealing.delivery.v1.DeliveryService.ListCharts
   */
  listCharts: {
    methodKind: "unary";
    input: typeof ListChartsRequestSchema;
    output: typeof ListChartsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_annealing_delivery_v1_service, 0);

